import React from 'react';
import {FormControl, FormHelperText, TextField} from "@material-ui/core";
import Autocomplete from '@material-ui/lab/Autocomplete';

export default function AutocompleteInput(props) {

    const {name, label, options, value, onChange, error = null, fullWidth = false, multiple = false, ...autocompleteProps} = props;
    const getOptionLabel = (option) => typeof option === 'string' ? option : option.title;
    const selectedValue = multiple ? (value || []) : options.find(element => element.title === value) || null;

    return (
        <FormControl
            variant='outlined'
            fullWidth={fullWidth}
            {...(error && {
                error: true
            })}
        >
            <Autocomplete
                name={name}
                label={label}
                onChange={onChange}
                options={options}
                value={selectedValue}
                multiple={multiple}
                getOptionLabel={getOptionLabel}
                getOptionSelected={(option, selected) => getOptionLabel(option) === getOptionLabel(selected)}
                renderInput={(params) => <TextField {...params} style={{ margin: "0px" }} label={label} variant="outlined" {...(error && {
                    error: true
                })}/>}
                {...autocompleteProps}
            />
            {error && <FormHelperText>{error}</FormHelperText>}
        </FormControl>
    )

}